import {emitYmEvent} from '@web-catalog/utils/analytics';

export const YmLogger = {
  logAppsClick: () => {
    emitYmEvent({
      eventName: 'header_menu_button_apps',
      params: {domain_311741675: 'apps'},
    });
  },
  logGamesClick: () => {
    emitYmEvent({
      eventName: 'header_menu_button_games',
      params: {domain_311741679: 'apps'},
    });
  },
  logDevClick: () => {
    emitYmEvent({
      eventName: 'header_menu_button_developers',
      params: {domain_311741763: 'apps'},
    });
  },
  logSupportClick: () => {
    emitYmEvent({
      eventName: 'header_menu_button_help',
      params: {domain_311741651: 'apps'},
    });
  },
  logDownloadRustoreClick: () => {
    emitYmEvent({
      eventName: 'header_menu_button_download',
      params: {domain_311741622: 'apps'},
    });
  },
  logLogoClick: () => {
    emitYmEvent({
      eventName: 'header_menu_button_logo',
      params: {domain_311741787: 'apps'},
    });
  },
  logMenuOpenClick: () => {
    emitYmEvent({
      eventName: 'header_menu_button',
      params: {domain_311741561: 'apps'},
    });
  },
  logSearchBoxOpenClick: () => {
    emitYmEvent({eventName: 'header_menu_button_search'});
  },
};
